import { render, staticRenderFns } from "./contract-group-datatable.component.vue?vue&type=template&id=525757c8&scoped=true&"
import script from "./contract-group-datatable.component.vue?vue&type=script&lang=ts&"
export * from "./contract-group-datatable.component.vue?vue&type=script&lang=ts&"
import style0 from "./contract-group-datatable.component.vue?vue&type=style&index=0&id=525757c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525757c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VExpandTransition,VIcon,VRow,VSpacer})
